var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookSquare = function SvgFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 2,
    y: 2,
    fill: "#fff",
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.114 12.313 13.47 10H11.25V8.5c0-.633.31-1.25 1.303-1.25h1.01V5.281s-.916-.156-1.791-.156c-1.828 0-3.022 1.108-3.022 3.113V10H6.719v2.313H8.75v5.59a8 8 0 0 0 2.5 0v-5.59z"
  })));
};
export default SvgFacebookSquare;